module.exports = __webpack_public_path__ + "img/ic_24_logo.0d861405.svg";